import { useFormSelector } from 'mrf/redux/ReduxHelper';
import DateTimeField from 'mrf/view/DateTimeField';
import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';
import FormCRUD from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import Select from 'mrf/view/Select';
import TextField from 'mrf/view/TextField';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PublicKeyForm({ history, match }) {

    const { t } = useTranslation();

    const context = useFormSelector({
        id: match?.params?.id,
        resource: 'communicationPublicKeys',
        endpoint: `/api/communicationPublicKeys/${match?.params?.id}`
    });

    return <FormCRUD
        title='Public Key'
        match={match}
        history={history}
        context={context}
        hideDelete
    >
        <Grid>
            <Col size={3}>
                <FetcherObjectSelect
                    label='Country'
                    field='countryId'
                    resource='countries'
                    displayAttribute='name'
                    required
                />
            </Col>
            <Col size={3}>
                <Select
                    label='Purpose'
                    field='purpose'
                    required
                >
                    <option key={0} value={"encryption"}>{t("Encryption")}</option>
                    <option key={1} value={"signature"}>{t("Signature")}</option>
                </Select>
            </Col>
            <Col size={3}>
                <DateTimeField
                    label='Creation date'
                    field='creationTimestamp'
                    required
                />
            </Col>
            <Col size={3}>
                <DateTimeField
                    label='Expiration date'
                    field='expirationTimestamp'
                    required
                />
            </Col>
            <Col size={12}>
                <TextField
                    label='Public Key'
                    field='publicKey'
                    required
                />
            </Col>
        </Grid>
    </FormCRUD>
}